import React from "react";
import {
  FaHeadset,
  FaRocket,
  FaShieldAlt,
} from "react-icons/fa";

import styles from "../styles_service/ServicesHero.module.css";

const benefits = [
  {
    title: "Secure & Reliable",
    description: "Built with security and compliance",
    icon: FaShieldAlt,
  },
  {
    title: "Scalable Solutions",
    description: "Designed to grow with your business",
    icon: FaRocket,
  },
  {
    title: "End-to-End Support",
    description: "From planning to deployment and beyond",
    icon: FaHeadset,
  },
];

export default function ServicesHero() {
  return (
    <section className={styles.heroSection} id="services-overview">
      <div className={styles.heroContent}>
        <div className={styles.copyColumn}>
          <nav className={styles.breadcrumb} aria-label="Breadcrumb">
            <a href="/">Home</a>
            <span aria-hidden="true">&gt;</span>
            <span>Services</span>
          </nav>

          <p className={styles.eyebrow}>Our Services</p>

          <h1 className={styles.title}>
            Digital Solutions That
            <br />
            Drive Efficiency and
            <br />
            Create Impact
          </h1>

          <p className={styles.description}>
            We build secure, scalable and future-ready digital solutions for
            government, enterprises and businesses worldwide.
          </p>

          <div className={styles.benefits}>
            {benefits.map((benefit) => {
              const Icon = benefit.icon;

              return (
                <article className={styles.benefitItem} key={benefit.title}>
                  <Icon className={styles.benefitIcon} aria-hidden="true" />
                  <div>
                    <h2>{benefit.title}</h2>
                    <p>{benefit.description}</p>
                  </div>
                </article>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
